import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, exhaustMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import * as TaxonomyActions from './taxonomy.actions';
import {TaxonomyClientService} from './taxonomy-client.service';
import {errorHappened} from '../app.types';
import {loadInitialConfig} from '../store/global.actions';


@Injectable()
export class TaxonomyEffects {

  loadTaxonomies$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TaxonomyActions.loadTaxonomies, TaxonomyActions.refreshTaxonomies, loadInitialConfig),
      exhaustMap(() => this.client.getAll()),
      map(data => TaxonomyActions.loadAllTaxonomiesSuccess({data})),
      catchError(error => of(errorHappened({error: {message: error.error}}))));
  });

  loadTaxonomiesByFilter = createEffect(() => {
    return this.actions$.pipe(
      ofType(TaxonomyActions.loadTaxonomiesByFilter),
      map(action => action.filter),
      exhaustMap((filter) => this.client.getByFilter(filter)),
      map(data => TaxonomyActions.loadFilteredTaxonomiesSuccess({data})),
      catchError(error => of(errorHappened({error: {message: error.error}}))));
  });
  refreshTaxonomiesLoaded$ = createEffect(() => {
    return this.actions$.pipe(ofType(
        TaxonomyActions.deleteTaxonomySuccess,
        TaxonomyActions.updateTaxonomySuccess,
        TaxonomyActions.createTaxonomySuccess
      ),
      map(data => TaxonomyActions.refreshTaxonomies()),
      catchError(error => of(errorHappened({error: {message: error.error}}))));
  });

  createTaxonomy$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TaxonomyActions.createTaxonomy),
      concatMap((action) => this.client.create(action.model)),
      map(data => TaxonomyActions.createTaxonomySuccess({data})),
      catchError(error => of(errorHappened({error: {message: error.error}})))
    );
  });

  updateTaxonomy$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TaxonomyActions.updateTaxonomy),
      concatMap((action) => this.client.update(action.model, action.id)),
      map(data => TaxonomyActions.updateTaxonomySuccess({data})),
      catchError(error => of(errorHappened({error: {message: error.error}})))
    );
  });

  deleteTaxonomy$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TaxonomyActions.deleteTaxonomy),
      concatMap((action) => this.client.delete(action.id)),
      map(_ => TaxonomyActions.deleteTaxonomySuccess()),
      catchError(error => of(errorHappened({error: {message: error.error}})))
    );
  });


  constructor(private actions$: Actions, private client: TaxonomyClientService) {
  }
}
